<div class="global-content">
  <mat-form-field class="full-width" (click)="getItemList()">
    <mat-label 
      >{{
      myPlaceholder
    }}</mat-label>
    <input
      matInput
      type="text"
      (click)="showList()"
      [matAutocomplete]="auto"
      [formControl]="selectControl"
    />
    <mat-hint class="message-info" *ngIf="hasHint()">{{ myHint }}</mat-hint>
  </mat-form-field>

  <mat-icon
    class="button-clear-filter btn-list"
    [matMenuTriggerFor]="menuPlantilla"
    *ngIf="results.length > 0 && !selectControl.value"
    matTooltip="Ver seleccionados"
    >info</mat-icon
  >

  <mat-icon
    class="button-clear-filter"
    *ngIf="selectControl.value"
    class="btn-list"
    (click)="reset()"
    matTooltip="Limpiar texto"
    >highlight_off</mat-icon
  >

  <mat-autocomplete #auto="matAutocomplete" 
  [panelWidth]="panelWidth"
  (closed)="onAutocompleteClosed()"
  >
    <mat-option
      *ngFor="let data of filteredData | async"
      [disabled]="isOptionDisabled(data)"
    >
    <!-- [disabled]="isChecboxDisabled(data)" -->
      <div (click)="optionClicked($event, data)">
        <mat-checkbox
          [checked]="data.selected"
          (change)="toggleSelection(data)"
          (click)="$event.stopPropagation()"
        >
          {{ data.item[showText] }}
        </mat-checkbox>
      </div>
    </mat-option>
  </mat-autocomplete>
</div>

<mat-menu #menuPlantilla="matMenu">
  <ng-template matMenuContent>
    <button class="btn-ment" *ngFor="let item of results" mat-menu-item>
      <span> {{ item[showText] }}</span>
    </button>
  </ng-template>
</mat-menu>
